module.exports = __webpack_public_path__ + "static/media/chevron-right-ic.557287ab.svg";